import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { PackagerStatus } from '../../../../../../../_base-shared/models/Status/PackagerStatus';
import { PackagerStatusService } from '../packager-status.service';

@Component({
  selector:    'app-packager-status-list',
  templateUrl: './packager-status-list.component.html',
  styleUrls:   ['./packager-status-list.component.scss']
})
export class PackagerStatusListComponent implements OnInit{
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  public packagerStatuses: PackagerStatus[];
  public displayedColumns: string[] = ['id', 'name', 'created_at', 'actions'];
  public actions: string[]          = ['Edit', 'Delete'];
  public isLoading                  = 0;
  public dataSource: MatTableDataSource<PackagerStatus>;
  public paginatorConfig            = {
    pageIndex: 0,
    pageSize:  10,
    length:    1
  };

  public search                     = new UntypedFormControl('');

  constructor(
    private toastr: ToastrService,
    public translateService: TranslateService,
    private packagerStatus: PackagerStatusService,
  ) {
  }

  ngOnInit(): void {
    this.fetchPackagerStatuses();
    this.search.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe(() => this.fetchPackagerStatuses());
  }

  private fetchPackagerStatuses(): void {
    this.dataSource = new MatTableDataSource<PackagerStatus>([]);
    this.isLoading++;
    const data = {
      per_page: this.paginatorConfig.pageSize,
      page:     this.paginatorConfig.pageIndex + 1,
      search:   this.search.value,
      append:   ['name']
    };

    this.packagerStatus.index(data).pipe(finalize(() => this.isLoading--))
      .subscribe(res => {
        this.packagerStatuses           = res.data;
        this.dataSource             = new MatTableDataSource<PackagerStatus>(res.data);
        this.dataSource.sort        = this.sort;
        this.paginatorConfig.length = res.meta.total;
      });
  }

  public paginatorChange($event: PageEvent): void {
    this.paginatorConfig.pageIndex = $event.pageIndex;
    this.paginatorConfig.pageSize  = $event.pageSize;
    this.paginatorConfig.length    = $event.length;
  }

  openDeleteDialog(statusId, $event): void {
    $event.preventDefault();
    Swal.fire({
      title:              this.translateService.instant('SHARED.warning'),
      text:               this.translateService.instant('SHARED.delete-item'),
      icon:               'warning',
      showCancelButton:   true,
      cancelButtonText:   this.translateService.instant('SHARED.cancel'),
      confirmButtonText:  this.translateService.instant('SHARED.delete'),
      confirmButtonColor: '#886AB5',
    }).then(res => {
      if (res.isConfirmed) {
        this.deletePackagerStatus(statusId);
      }
    });
  }

  public deletePackagerStatus(statusId: number): void {
    this.packagerStatus.delete(statusId)
      .subscribe(res => {
          this.fetchPackagerStatuses();
          this.toastr.success(this.translateService.instant('PACKAGER.packager_status.list.actions.delete.result.success'));
        },
        error => {
          this.toastr.error(this.translateService.instant('SHARED.went-wrong'));
        });
  }
}
